import React, { SyntheticEvent } from "react";
import { Tabs, Tab, Typography } from "@mui/material";
import { TabMenu } from "../../types";

type ToggleButtonGroupProps = {
    active: string;
    tabsMenu: TabMenu[];
    handleChange: (e: SyntheticEvent, value: string) => void;
    custombuttonbarsx?: Object;
};

export default function CustomToggleButtonGroup(props: ToggleButtonGroupProps) {
    const { active, tabsMenu, handleChange, custombuttonbarsx } = props;
    return (
        <Tabs
            value={active}
            onChange={handleChange}
            TabIndicatorProps={{
                style: {
                    display: "none",
                    fontWeight: "600",
                },
            }}
            sx={{
                display: "inline-flex",
                justifyContent: "center",
                alignItems: "center",
                borderRadius: "9.375rem",
                border: "1px solid  #E3E6E8",
                boxShadow: " 0px 4px 30px 0px #E3E6E8",
                float: "right",
                height: "38px",
                minHeight: "unset",
                padding: "0 0.25rem",
                "@media (max-width:1024px)": {
                    float: "none",
                    width: "100%",
                },
                ".MuiTabs-flexContainer": {
                    justifyContent: "space-between",
                },
            }}
        >
            {tabsMenu.map((menuItem: TabMenu) => {
                const { key, name } = menuItem;
                const isActiveTab = active === key;

                const activeTabSx = isActiveTab
                    ? {
                          borderRadius: "1.25rem",
                          border: "1px solid  #E3E6E8",
                          background: "#005499",
                          boxShadow: " 0px 4px 30px 0px #E3E6E8",
                          height: "30px",
                          minHeight: "unset",
                      }
                    : {};

                return (
                    <Tab
                        label={
                            <Typography
                                sx={{
                                    overflow: "hidden",
                                    textAlign: "center",
                                    textOverflow: "ellipsis",
                                    fontFamily: "Roboto",
                                    fontSize: "0.75rem",
                                    fontStyle: "normal",
                                    fontWeight: "700",
                                    lineHeight: "normal",
                                    display: "-webkit-box",
                                    webkitBoxOrient: "vertical",
                                    webkitLineClamp: 1,
                                    color: isActiveTab ? "#FFF" : "#005499",
                                    height: "30px",
                                    minHeight: "unset",
                                    textTransform: "none",
                                }}
                            >
                                {name}
                            </Typography>
                        }
                        key={key}
                        value={key}
                        sx={{
                            display: "flex",
                            padding: "0.5rem 1rem",
                            justifyContent: "center",
                            alignItems: "center",
                            height: "30px",
                            minHeight: "unset",

                            ...activeTabSx,
                            ...custombuttonbarsx,
                        }}
                    />
                );
            })}
        </Tabs>
    );
}
